import React from 'react';
import { useDocumentHelper } from '@hmhco/document-helper';
import { FormattedMessage, useIntl } from 'react-intl';
import { usePlatform } from '@hmhco/platform-helper';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import TenantPickerLayout from '../../Layout/TenantPickerLayout';
import Logo from '../../Logo/Logo';
import useStyles from './LoggedOutPage.styles';
import { LoginOptions } from '../../../LoginOptions/LoginOptions';
import {
  LOGIN_METHOD_KEY,
  LOGIN_METHODS,
} from '../../../../constants/constants';
import { LOCAL_STORAGE_CONNECTION_KEY } from '../../../../constants/storageConstants';

const LoggedOutPage = () => {
  const { formatMessage } = useIntl();
  const { classes } = useStyles();
  const platform = usePlatform();

  const ariaTitle = formatMessage({ id: 'loggedOut.title.aria' }, { platform });
  const isSso = localStorage.getItem(LOGIN_METHOD_KEY) === LOGIN_METHODS.SSO;
  const pid = localStorage.getItem(LOCAL_STORAGE_CONNECTION_KEY);
  const buttonHref = pid ? `/ui/login/?connection=${pid}` : '/ui/login/';
  useDocumentHelper(ariaTitle);

  return (
    <TenantPickerLayout>
      <header>
        <Logo />
        <div className={classes.heading}>
          <Typography component="h1" variant="h3" aria-label={ariaTitle}>
            <FormattedMessage id="loggedOut.title" />
          </Typography>
        </div>
      </header>
      <main className={classes.main}>
        <Typography>
          <FormattedMessage id="loggedOut.description" />
        </Typography>
        {isSso ? (
          <LoginOptions platform={platform} />
        ) : (
          <>
            <Button
              className={classes.returnBtn}
              color="primary"
              size="small"
              variant="outlined"
              component={Link}
              href={buttonHref}
            >
              <FormattedMessage id="loggedOut.backButton" />
            </Button>
          </>
        )}
      </main>
    </TenantPickerLayout>
  );
};

export default LoggedOutPage;
